module.exports = __webpack_public_path__ + "img/ActiveCampaign.38c6bf10.svg";